import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import styled from 'styled-components';

import { SortValue } from '../types';

type Props = {
  current: SortValue;
  sortValues: SortValue[];
  onChange: (orderBy: SortValue['value']) => void;
};

export const Sorter: React.FC<Props> = ({ current, sortValues, onChange }) => (
  <Styled>
    <Dropdown
      className="dropdown"
      data-test="order-by-dropdown"
      options={sortValues.map((sortValue, i) => ({
        active: current.value ? current.value === sortValue.value : false,
        'data-test': `order-by-value[${sortValue.value}]`,
        key: i,
        onClick: () => onChange(sortValue.value),
        text: sortValue.label,
        value: sortValue.value,
      }))}
      selection={true}
      text={current.label}
      value={current.value}
    />
  </Styled>
);

const Styled = styled.div`
  .dropdown {
    margin-left: auto;
  }
`;
